import { render, staticRenderFns } from "./cardDetails.vue?vue&type=template&id=839645f4&scoped=true&"
import script from "./cardDetails.vue?vue&type=script&lang=ts&"
export * from "./cardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./cardDetails.vue?vue&type=style&index=0&id=839645f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839645f4",
  null
  
)

export default component.exports